export const INJECTION_CONFIG_FIELDS = ['frame_script', 'frame_style', 'host_options'];
